import Vue from 'vue'

/**
 * 2016 Acceptance Testing Forms
 *
 * Version 1.0
 */
Vue.component('automatic-time-switch-acceptance-test-2016', require('./NRCA-LTI-02-A/AutomaticTimeSwitch'));
Vue.component('occupancy-sensor-acceptance-test-2016', require('./NRCA-LTI-02-A/OccupancySensor'));
Vue.component('occupancy-sensor-part-of-large-area-2016', require('./NRCA-LTI-02-A/OccupancySensorPartOfLargeArea'));
Vue.component('partial-off-occupancy-sensor-acceptance-procedure-2016', require('./NRCA-LTI-02-A/PartialOffOccupancySensor'));
Vue.component('partial-on-occupancy-sensor-acceptance-procedure-2016', require('./NRCA-LTI-02-A/PartialOnOccupancySensor'));

Vue.component('automatic-daylight-continuous-dimming-power-option-2016', require('./NRCA-LTI-03-A/AutomaticDaylightContinuousDimmingPowerOption'));
Vue.component('automatic-daylight-step-dimming-power-option-2016', require('./NRCA-LTI-03-A/AutomaticDaylightStepDimmingPowerOption'));
Vue.component('automatic-daylight-continuous-dimming-lightmeter-2016', require('./NRCA-LTI-03-A/AutomaticDaylightContinuousDimmingLightmeter'));

Vue.component('demand-response-lightmeter-option-2016', require('./NRCA-LTI-04-A/DemandResponseLightmeterOption'));
Vue.component('demand-response-power-option-2016', require('./NRCA-LTI-04-A/DemandResponsePowerOption'));

Vue.component('observation-2016', require('./NRCA-LTI-05-A/InstitutionalTuningPowerObservation'));
Vue.component('verification-2016', require('./NRCA-LTI-05-A/InstitutionalTuningPowerVerification'));

Vue.component('outside-motion-sensor-2016', require('./NRCA-LTO-02-A/OutsideMotionSensor'));
Vue.component('photocontrol-2016', require('./NRCA-LTO-02-A/Photocontrol'));
Vue.component('astronomical-time-switch-control-2016', require('./NRCA-LTO-02-A/AstronomicalTimeSwitchControl'));
Vue.component('part-night-outdoor-lighting-control-2016', require('./NRCA-LTO-02-A/PartNightOutdoorLightingControl'));
Vue.component('automatic-scheduling-controls-2016', require('./NRCA-LTO-02-A/AutomaticSchedulingControl'));
